/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: '较大',
	['预设']: '预设',
	['较小']: '较小',
	['字级大小']: '字级大小',
	['页面正在加载中']: '页面正在加载中',
	['这可能需要几分钟的时间，请耐心等待']: '这可能需要几分钟的时间，请耐心等待',
	['您所访问的页面不存在']: '您所访问的页面不存在',
	['开始对话']: '开始对话',
	['充值未到帐快速通道']: '充值未到帐快速通道',
	['人工客服']: '人工客服',
	['已接听']: '已接听',
	['结束对话']: '结束对话',
	['联络人工客服']: '联络人工客服',
	['重新选择智能客服']: '重新选择智能客服',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: '感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！',
	['您觉得此次的服务品质如何？']: '您觉得此次的服务品质如何？',
	['颗星']: '颗星',
	['颗星(單數)']: '颗星',
	['不评分']: '不评分',
	['点选下方即可结束对话']: '点选下方即可结束对话',
	['请输入您的ID']: '请输入您的ID',
	['ID不能为空']: 'ID不能为空',
	['说明文字']: '说明文字',
	['送出']: '送出',
	['系统维护中']: '系统维护中',
	['储存']: '储存',
	['确认']: '确认',
	['取消']: '取消',
	['完成']: '完成',
	['协作']: '协作',
	['转接']: '转接',
	['批量转接']: '批量转接',
	['已选 {{count}} 则对话']: '已选 {{count}} 则对话',
	['勾选']: '勾选',
	['全平台服务人数']: '全平台服务人数',
	['未开启{{platform}}平台']: '未开启{{-platform}}平台',
	['离开']: '离开',
	['请选择服务对象开始通话']: '请选择服务对象开始通话',
	['请填写表单']: '请填写表单',
	['本对话已经结束']: '本对话已经结束',
	['客服已逾 {{second}} 秒未回应']: '客服已逾 {{second}} 秒未回应',
	['历史对话']: '历史对话',
	['查无资料']: '查无资料',
	['标签']: '标签',
	['正在输入中...']: '正在输入中...',
	['于']: '于',
	['档案容量限制']: '档案容量限制',
	['不能为空']: '不能为空',
	['提交']: '提交',
	['满意度']: '满意度',
	['IP未知']: 'IP未知',
	['地区未知']: '地区未知',
	['使用者环境未知']: '使用者环境未知',
	['关闭']: '关闭',
	['全萤幕截图成档案']: '全萤幕截图成档案',
	['Mac用户']: 'Mac用户',
	['Windows用户']: 'Windows用户',
	['Windows键']: 'Windows键',
	['全萤幕截图至剪贴簿']: '全萤幕截图至剪贴簿',
	['截图完成后请直接于文字输入处贴上']: '截图完成后请直接于文字输入处贴上',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: '使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上',
	['截图']: '截图',
	['档案']: '档案',
	['下载失败']: '下载失败',
	['请输入分类名称']: '请输入分类名称',
	['新增']: '新增',
	['更新']: '更新',
	['请选择一个分类']: '请选择一个分类',
	['请输入标题']: '请输入标题',
	['请输入内文']: '请输入内文',
	['请上传图片']: '请上传图片',
	['快捷语']: '快捷语',
	['图片']: '图片',
	['管理分类']: '管理分类',
	['新增分类']: '新增分类',
	['标题/内文']: '标题/内文',
	['分类']: '分类',


	['编辑']: '编辑',
	['删除']: '删除',
	['平台名称']: '平台名称',
	['显示']: '显示',
	['编辑服务平台']: '编辑服务平台',
	['若有服务中的客户，无法关闭服务平台']: '若有服务中的客户，无法关闭服务平台',
	['确定']: '确定',
	['人员列表']: '人员列表',
	['服务人数']: '服务人数',
	['选择转接人员']: '选择转接人员',
	['按此上传图片']: '按此上传图片',
	['确定要取消{{displayName}}协作邀请吗？']: '确定要取消{{-displayName}}协作邀请吗？',
	['确定要结束{{displayName}}的协作吗？']: '确定要结束{{-displayName}}的协作吗？',
	['等待协作中']: '等待协作中',
	['协作中']: '协作中',
	['负责人']: '负责人',
	['已选择']: '已选择',
	['可协作人数已满']: '可协作人数已满',
	['选择协作人员']: '选择协作人员',
	['提示']: '提示',
	['请输入讯息']: '请输入讯息',
	['确定已經完成？']: '确定已經完成？',
	['常用图片']: '常用图片',
	['用户']: '用户',
	['个人']: '个人',
	['公共']: '公共',
	['开始谈话']: '开始谈话',
	['等待中']: '等待中',
	['客户已离开对话']: '客户已离开对话',
	['正在转接给']: '正在转接给',
	['邀请你加入协作']: '邀请你加入协作',
	['请求转接']: '请求转接',
	['正在服务中']: '正在服务中',
	['编辑平台']: '编辑平台',
	['您的连线已中断']: '您的连线已中断',
	['正尝试重新连线']: '正尝试重新连线',
	['重新登入']: '重新登入',
	['请先登入']: '请先登入',
	['帐号']: '帐号',
	['帐号不能为空']: '帐号不能为空',
	['请输入帐号']: '请输入帐号',
	['密码']: '密码',
	['密码不能为空']: '密码不能为空',
	['请输入密码']: '请输入密码',
	['登录']: '登录',
	['客服系统客服端']: '客服系统客服端',


	['平台异动，请重新整理']: '平台异动，请重新整理',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: '客服系统升级维护中，请您晚点再联系线上客服，谢谢',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: '客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服',
	['请稍后再试']: '请稍后再试',
	['是']: '是',
	['否']: '否',
	['等于']: '等于',
	['包含']: '包含',
	['排除']: '排除',
	['大于']: '大于',
	['少于']: '少于',
	['数量区间']: '数量区间',
	['客服对话数']: '客服对话数',
	['客戶对话数']: '客戶对话数',
	['即时资讯']: '即时资讯',
	['报表分析']: '报表分析',
	['平均通话时间']: '平均通话时间',
	['回覆通话数']: '回覆通话数',
	['平均等待时间']: '平均等待时间',
	['客户满意度']: '客户满意度',
	['历史对话记录']: '历史对话记录',
	['操作日志']: '操作日志',
	['智能客服设定']: '智能客服设定',
	['机器人设定']: '机器人设定',
	['版本管理']: '版本管理',
	['档案总览']: '档案总览',
	['设定']: '设定',
	['公司管理']: '公司管理',
	['维修管理']: '维修管理',
	['一般设定']: '一般设定',
	['公告管理']: '公告管理',
	['帐号管理']: '帐号管理',
	['平台管理']: '平台管理',
	['角色管理']: '角色管理',
	['团队管理']: '团队管理',
	['标签管理']: '标签管理',
	['查询']: '查询',
	['重置']: '重置',
	['今天']: '今天',
	['昨天']: '昨天',
	['过去7天']: '过去7天',
	['过去10天']: '过去10天',
	['过去一个月']: '过去一个月',
	['过去90天']: '过去90天',
	['LOGO 预览']: 'LOGO 预览',
	['档案格式：PNG、JPG，长宽不超过']: '档案格式：PNG、JPG，长宽不超过',
	['档案太大或格式不支援']: '档案太大或格式不支援',
	['且档案大小不得大于']: '且档案大小不得大于',
	['上传档案']: '上传档案',
	['新增IP白名单成功']: '新增IP白名单成功',
	['删除IP白名单成功']: '删除IP白名单成功',
	['请输入欲查询的IP']: '请输入欲查询的IP',
	['请输入IP']: '请输入IP',
	['备注']: '备注',
	['备注不能为空']: '备注不能为空',
	['请输入备注']: '请输入备注',
	['新增时间']: '新增时间',
	['操作']: '操作',
	['IP白名单']: 'IP白名单',
	['新增IP']: '新增IP',
	['新增IP白名单']: '新增IP白名单',
	['确定删除此IP?']: '确定删除此IP?',
	['平台']: '平台',
	['团队']: '团队',
	['全体']: '全体',
	['客服']: '客服',
	['客服系统']: '客服系统',
	['个人帐号设定']: '个人帐号设定',
	['最少6码']: '最少6码',
	['最多20码']: '最多20码',
	['不能有空白']: '不能有空白',
	['应至少包含1个英文和数字']: '应至少包含1个英文和数字',
	['公司名称']: '公司名称',
	['僅能输入英文和数字']: '僅能输入英文和数字',
	['应至少包含1个英文']: '应至少包含1个英文',
	['最少5码']: '最少5码',
	['IP不能为空']: 'IP不能为空',
	['非IP位址']: '非IP位址',
	['最多500个字']: '最多500个字',
	['启用']: '启用',
	['禁用']: '禁用',
	['对话量']: '对话量',
	['目前客户数']: '目前客户数',
	['目前客服数']: '目前客服数',
	['接通对话量']: '接通对话量',
	['全部']: '全部',
	['最近一天']: '最近一天',
	['最近一周']: '最近一周',
	['最近一月']: '最近一月',
	['新增过滤器']: '新增过滤器',
	['请输入模組名称']: '请输入模組名称',
	['储存过滤模組']: '储存过滤模組',
	['读取过滤模組']: '读取过滤模組',
	['确定要删除模組']: '确定要删除模組',
	['分钟']: '分钟',
	['接通时间']: '接通时间',
	['通话时间']: '通话时间',
	['请选择或输入时间']: '请选择或输入时间',
	['等待时间']: '等待时间',
	['对话搜寻']: '对话搜寻',
	['请输入对话']: '请输入对话',
	['客戶 ID']: '客戶 ID',
	['请输入客戶ID']: '请输入客戶ID',
	['对话浏览模式']: '对话浏览模式',
	['筆']: '筆',
	['客服本名']: '客服本名',
	['进入时间']: '进入时间',
	['客服昵称']: '客服昵称',
	['客服系统管理端']: '客服系统管理端',
	['数量']: '数量',
	['尚未上传档案']: '尚未上传档案',
	['输入文字']: '输入文字',
	['请在此输入文字']: '请在此输入文字',
	['添加项目']: '添加项目',
	['请选择']: '请选择',
	['新增文字']: '新增文字',
	['新增档案']: '新增档案',
	['選項']: '選項',
	['勾选标题']: '勾选标题',
	['文字內容不能为空']: '文字內容不能为空',
	['添加']: '添加',
	['上传标题']: '上传标题',
	['单选标题']: '单选标题',
	['输入框标题']: '输入框标题',
	['请输入']: '请输入',
	['输入框']: '输入框',
	['单选']: '单选',
	['核取方块']: '核取方块',
	['请选择一个标签']: '请选择一个标签',
	['确定要删除此项目和其所有子项目？']: '确定要删除此项目和其所有子项目？',
	['答案']: '答案',
	['表单']: '表单',
	['清除此阶层设定']: '清除此阶层设定',
	['请输入此阶层问题']: '请输入此阶层问题',
	['新增选项']: '新增选项',
	['新增表单']: '新增表单',
	['新增答案']: '新增答案',
	['新增充值表单']: '新增充值表单',
	['若切换种类后, 将清除原有的和其子项目资料']: '若切换种类后, 将清除原有的和其子项目资料',
	['确定要清除所有资料和其子项目资料？']: '确定要清除所有资料和其子项目资料？',
	['阶层']: '阶层',
	['开场语']: '开场语',
	['开场语不能为空']: '开场语不能为空',
	['结尾感谢语']: '结尾感谢语',
	['结尾感谢语不能为空']: '结尾感谢语不能为空',
	['发布']: '发布',
	['复制']: '复制',
	['选择目的平台']: '选择目的平台',
	['确定复制到']: '确定复制到',
	['是否要正式发布到使用环境？']: '是否要正式发布到使用环境？',
	['储存版本']: '储存版本',
	['版本名称']: '版本名称',
	['请输入版本名称']: '请输入版本名称',
	['确定是否储存此版本']: '确定是否储存此版本',
	['版本储存成功']: '版本储存成功',
	['最多10个字']: '最多10个字',
	['公告一']: '公告一',
	['公告二']: '公告二',
	['公告三']: '公告三',
	['公告储存成功']: '公告储存成功',
	['标题']: '标题',
	['內文']: '內文',
	['修改登入密码']: '修改登入密码',
	['修改基本资讯']: '修改基本资讯',
	['昵称']: '昵称',
	['昵称不能为空']: '昵称不能为空',
	['请输入昵称']: '请输入昵称',
	['本名']: '本名',
	['本名不能为空']: '本名不能为空',
	['请输入本名']: '请输入本名',
	['选择图像']: '选择图像',
	['状态']: '状态',

	['平台代码']: '平台代码',
	['平台代码不能为空']: '平台代码不能为空',
	['使用ID模式登入']: '使用ID模式登入',
	['新增平台']: '新增平台',
	['修改平台']: '修改平台',
	['确定重新产生Key/IV?']: '确定重新产生Key/IV?',
	['进入公司成功']: '进入公司成功',
	['确定禁用公司?']: '确定禁用公司?',
	['确定启用公司?']: '确定启用公司?',
	['修改公司']: '修改公司',
	['进入公司']: '进入公司',
	['确定进入公司?']: '确定进入公司?',
	['新增标签']: '新增标签',
	['代号']: '代号',
	['代号不可为空']: '代号不可为空',
	['名称']: '名称',
	['名称不可为空']: '名称不可为空',
	['颜色']: '颜色',
	['颜色不可为空']: '颜色不可为空',
	['进入标签']: '进入标签',
	['修改标签']: '修改标签',
	['确定开启进入标签?']: '确定开启进入标签?',
	['确定关闭进入标签?']: '确定关闭进入标签?',
	['确定删除此标签?']: '确定删除此标签?',
	['标签创建成功']: '标签创建成功',
	['标签更新成功']: '标签更新成功',
	['进入标签更新成功']: '进入标签更新成功',
	['标签删除成功']: '标签删除成功',
	['请输入代号、名称等关键字']: '请输入代号、名称等关键字',
	['设定开场白成功']: '设定开场白成功',
	['客戶进入开场白']: '客戶进入开场白',
	['客戶进入开场白不可为空']: '客戶进入开场白不可为空',
	['第一次通知时间']: '第一次通知时间',
	['第{{count}}次通知时间']: '第{{count}}次通知时间',
	['设置错误']: '设置错误',
	['设定等待过长通知时间成功']: '设定等待过长通知时间成功',
	['秒']: '秒',
	['对话自动断开时间']: '对话自动断开时间',
	['未发话时间']: '未发话时间',
	['未发话提示文字']: '未发话提示文字',
	['设定对话断开成功']: '设定对话断开成功',
	['Favicon预览']: 'Favicon预览',
	['更换 Favicon 成功']: '更换 Favicon 成功',
	['档案格式：ICO，長寬不超過 32x32 px']: '档案格式：ICO，長寬不超過 32x32 px',
	['更换 LOGO 成功']: '更换 LOGO 成功',
	['智能客服']: '智能客服',
	['设定通道成功']: '设定通道成功',
	['设定提示音效成功']: '设定提示音效成功',
	['单音']: '单音',
	['循环音']: '循环音',
	['编号']: '编号',
	['资料类型']: '资料类型',
	['资料类型不可为空']: '资料类型不可为空',
	['数字']: '数字',
	['字串']: '字串',
	['布林']: '布林',
	['建立标签成功']: '建立标签成功',
	['修改标签成功']: '修改标签成功',
	['删除标签成功']: '删除标签成功',
	['更换 LOGO']: '更换 LOGO',
	['更换 Favicon']: '更换 Favicon',
	['对话断开']: '对话断开',
	['等待过长通知时间']: '等待过长通知时间',
	['开场白']: '开场白',
	['提示音效设定']: '提示音效设定',
	['通道设定']: '通道设定',
	['自定义标签']: '自定义标签',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: '开启维修模式将会停止客服系统运作。确定要开启嗎？',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: '关闭维修模式，客服系统将会继续运作。确定要关闭嗎？',
	['状态更新成功']: '状态更新成功',
	['通知讯息更新成功']: '通知讯息更新成功',
	['维修模式']: '维修模式',
	['通知讯息设定']: '通知讯息设定',
	['尚未连线状态']: '尚未连线状态',
	['尚未连线状态描述']: '尚未连线状态描述',
	['已连线状态']: '已连线状态',
	['已连线状态描述']: '已连线状态描述',
	['开启成功']: '开启成功',
	['关闭成功']: '关闭成功',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: '关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: '开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？',
	['请输入帐号、昵称、角色等关键字']: '请输入帐号、昵称、角色等关键字',
	['新增角色']: '新增角色',
	['修改角色']: '修改角色',
	['角色创建成功']: '角色创建成功',
	['角色更新成功']: '角色更新成功',
	['角色删除成功']: '角色删除成功',
	['请输入角色名称，平台，权限等关键字']: '请输入角色名称，平台，权限等关键字',
	['关键字']: '关键字',
	['角色名称']: '角色名称',
	['角色名称不可为空']: '角色名称不可为空',
	['请输入角色名称']: '请输入角色名称',
	['上级角色']: '上级角色',
	['上级角色不可为空']: '上级角色不可为空',
	['权限']: '权限',
	['确定删除此角色?']: '确定删除此角色?',
	['图像不能为空']: '图像不能为空',
	['新增团队']: '新增团队',
	['修改团队']: '修改团队',
	['团队创建成功']: '团队创建成功',
	['团队修改成功']: '团队修改成功',
	['团队删除成功']: '团队删除成功',
	['人数']: '人数',
	['新登入密码']: '新登入密码',
	['新密码不能设定與舊密码相同']: '新密码不能设定與舊密码相同',
	['新密码與確認密码不相同']: '新密码與確認密码不相同',
	['确定修改登入密码?']: '确定修改登入密码?',
	['登入密码修改成功，请重新登入']: '登入密码修改成功，请重新登入',
	['个人资讯']: '个人资讯',
	['搜寻快捷语']: '搜寻快捷语',
	['登出']: '登出',
	['帐密错误']: '帐密错误',
	['一']: '一',
	['二']: '二',
	['三']: '三',
	['四']: '四',
	['五']: '五',
	['六']: '六',
	['七']: '七',
	['请输入客服本名、客服昵称等关键字']: '请输入客服本名、客服昵称等关键字',
	['共 {{count}} 筆资料']: '共 {{count}} 筆资料',
	['平台语言不能为空']: '平台语言不能为空',
	['开启']: '开启',
	['语言']: '语言',
	['切换语言']: '切换语言',
	['语言名称']: '语言名称',
	['系统设定']: '系统设定',
	['储存成功']: '储存成功',
	['发布成功']: '发布成功',
	['复制成功']: '复制成功',
	['项目选取']: '项目选取',
	['图像']: '图像',
	['角色']: '角色',
	['新增帐号']: '新增帐号',
	['角色不能为空']: '角色不能为空',
	['登入密码']: '登入密码',
	['请输入代号、名称、备注等关键字']: '请输入代号、名称、备注等关键字',
	['确定删除此团队?']: '确定删除此团队?',

	['切换语言成功']: '切换语言成功',
	['确定要切换语言?']: '确定要切换语言?',
	['选项']: '选项',
	['选择语言']: '选择语言',
	['修改成功']: '修改成功',
	['舊登入密码']: '舊登入密码',
	['確認新登入密码']: '確認新登入密码',
	['语言切换成功，將重整页面以套用更新']: '语言切换成功，將重整页面以套用更新',
	['笔 / 页']: '笔 / 页',
	['时段搜寻']: '时段搜寻',
	['请选择时段']: '请选择时段',
	['更换背景色']: '更换背景色',
	['设定背景颜色成功']: '设定背景颜色成功',
	['请重新登入']: '请重新登入',
	['绑定谷歌验证']: '绑定谷歌验证',
	['解除绑定']: '解除绑定',
	['谷歌验证状态']: '谷歌验证状态',
	['已绑定']: '已绑定',
	['未绑定']: '未绑定',
	['解绑谷歌验证失败']: '解绑谷歌验证失败',
	['二维码方式添加']: '二维码方式添加',
	['请在 Google 身份验证器中采用添加条形码方式添加']: '请在 Google 身份验证器中采用添加条形码方式添加',
	['密钥方式添加']: '密钥方式添加',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: '请在 Google 身份验证器中采用输入提供的密钥方式添加',
	['密钥如下所示']: '密钥如下所示',
	['请再次输入登入密码']: '请再次输入登入密码',
	['谷歌6位动态密码']: '谷歌6位动态密码',
	['请绑定谷歌验证']: '请绑定谷歌验证',
	['谷歌验证绑定成功']: '谷歌验证绑定成功',
	['解绑谷歌验证成功']: '解绑谷歌验证成功',
	['确定解绑谷歌验证？']: '确定解绑谷歌验证？',
	['请输入谷歌动态码']: '请输入谷歌动态码',
	['谷歌动态码']: '谷歌动态码',
	['谷歌动态码不能为空']: '谷歌动态码不能为空',
	['谷歌动态码长度6码']: '谷歌动态码长度6码',
	['谷歌动态码错误']: '谷歌动态码错误',
	['內容']: '內容',
	['搜寻']: '搜寻',
	['连线中断，点击“确定”即重新连线客服。']: '连线中断，点击“确定”即重新连线客服。',
	['充值表单']: '充值表单',
	['网银充值']: '网银充值',
	['扫码充值']: '扫码充值',
	['带入目前帐号']: '带入目前帐号',
	['自行输入平台帐号']: '自行输入平台帐号',
	['充值方式']: '充值方式',
	['平台帐号']: '平台帐号',
	['充值金额']: '充值金额',
	['付款人姓名']: '付款人姓名',
	['确认语']: '确认语',




	['操作时间']: '操作时间',
	['操作者']: '操作者',
	['请输入备注等关键字']: '请输入备注等关键字',
	['操作类型']: '操作类型',
	['修改平台昵称']: '修改平台昵称',
	['修改平台昵称成功']: '修改平台昵称成功',
	['输入格式错误']: '输入格式错误',
	['套用']: '套用',
	['确定套用到']: '确定套用到',
	['套用成功']: '套用成功',
	['储存方式']: '储存方式',
	['储存時間']: '储存時間',
	['系统发布']: '系统发布',
	['手动储存']: '手动储存',
	['自动储存']: '自动储存',
	['预览']: '预览',
	['最多350个字']: '最多350个字',
	['修改']: '修改',
	['共同资讯管理']: '共同资讯管理',
	['共同资讯创建成功']: '共同资讯创建成功',
	['共同资讯修改成功']: '共同资讯修改成功',
	['新增共同资讯']: '新增共同资讯',
	['修改共同资讯']: '修改共同资讯',
	['删除成功']: '删除成功',
	['已设置于其他答案，无法删除']: '已设置于其他答案，无法删除',
	['请输入名称、内容等关键字']: '请输入名称、内容等关键字',
	['确定删除此共同资讯？']: '确定删除此共同资讯？',
	['共同资讯']: '共同资讯',
	['尚未选择共同资讯']: '尚未选择共同资讯',
	['选择共同资讯']: '选择共同资讯',
	['选择']: '选择',
	['点击「确定」后，即覆盖该平台的快捷语设定']: '点击「确定」后，即覆盖该平台的快捷语设定',
	['已复制：目的平台']: '已复制：目的平台',
	['是否离开客服系统？']: '是否离开客服系统？',
	['感谢您的作答，此次评分为：{{score}}分']: '感谢您的作答，此次评分为：{{score}}分',
	['共 {{count}} 筆']: '共 {{count}} 筆',
	['分']: '分', // 分鐘
	['新增公司']: '新增公司',
	['翻译']: '翻译',
	['翻译中']: '翻译中',
	['显示原文']: '显示原文',
	['解绑谷歌验证']: '解绑谷歌验证',
	['请输入名称 内容等关键字']: '请输入名称 内容等关键字',
	['表单选项']: '表单选项',
	['年']: '年',
	['等待时间颜色设定']: '等待时间颜色设定',
	['显示颜色']: '显示颜色',
	['确认删除此规则?']: '确认删除此规则?',
	['页签']: '页签',
	['超过 {{time}} 分钟']: '超过 {{-time}} 分钟',
	['新增成功']: '新增成功',
	['删除完成']: '删除完成',
	['等待时间(分钟)']: '等待时间(分钟)',
	['时间']: '时间',
	['不可为空']: '不可为空',
	['需为正整数']: '需为正整数',
	['按平台名称排列(A-Z)']: '按平台名称排列(A-Z)',
	['按平台名称排列(Z-A)']: '按平台名称排列(Z-A)',
	['旧版面模式']: '旧版面模式',
	['自动翻译']: '自动翻译',
	['功能設定']: '功能設定',
	['确认切换版面？']: '确认切换版面？',
	['确认开启自动翻译？']: '确认开启自动翻译？',
	['确认关闭自动翻译？']: '确认关闭自动翻译？',
	['原文']: '原文',
	['泰语']: '泰语',
	['追踪']: '追踪',
	['取消追踪']: '取消追踪',
	['预览影片']: '预览影片',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: '仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案',
	['请勿输入语法相关字串']: '请勿输入语法相关字串',
	['输入名称']: '输入名称',
	['设为预设版本']: '设为预设版本',
	['另存为新版本']: '另存为新版本',
	['请选择版本']: '请选择版本',
	['一键开关']: '一键开关',
	['若有服务中的客户，无法关闭服务平台与切换版本']: '若有服务中的客户，无法关闭服务平台与切换版本',
	['是否确认要覆盖已有的设定，储存新的设定？']: '是否确认要覆盖已有的设定，储存新的设定？',
	['已储存超过五个版本']: '已储存超过五个版本',
	['版本已变动，是否需要储存？']: '版本已变动，是否需要储存？',
	['确定删除此版本？']: '确定删除此版本？',
	['编辑版本']: '编辑版本',
	['侦测到重复联系客服系统，若非您本人请告知客服']: '侦测到重复联系客服系统，若非您本人请告知客服',
	['删除此版本']: '删除此版本',
	['刪除成功']: '刪除成功',
	['刪除失敗']: '刪除失敗',
	['儲存成功']: '儲存成功',
	['儲存失敗']: '儲存失敗',
	['您好，请问要选择哪个问题？']: '您好，请问要选择哪个问题？',
	['等待服务区']: '等待服务区',
	['按时间排列(長到短)']: '按时间排列(長到短)',
	['按时间排列(短到長)']: '按时间排列(短到長)',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: '亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...',
	['编辑标签']: '编辑标签',
	['于 {{time}} 侦测到会员【稍早已离线】']: '于 {{-time}} 侦测到会员【稍早已离线】',
	['{{score}}分']: '{{score}}分', // 分數
	['未评分']: '未评分',
	['客服完成']: '客服完成',
	['会员离线']: '会员离线',
	['超时自动断线']: '超时自动断线',
	['{{text}}不可重复']: '{{-text}}不可重复',
	['{{text}}不能为空']: '{{-text}}不能为空',
	['{{text}}设置错误']: '{{-text}}设置错误',
	['平均通话时长']: '平均通话时长',
	['平均通话数']: '平均通话数',
	['请选择角色名称']: '请选择角色名称',
	['请选择客服']: '请选择客服',
	['请选择团队']: '请选择团队',
	['播放']: '播放',
	['统计时间']: '统计时间',
	['统计时间不可为空']: '统计时间不可为空',
	['请输入时间']: '请输入时间',
	['时间筛选']: '时间筛选',
	['汇出']: '汇出',
	['未出勤']: '未出勤',
	['客服平均通话时长']: '客服平均通话时长',
	['数量筛选']: '数量筛选',
	['客服平均等待时间']: '客服平均等待时间',
	['上一个月']: '上一个月',
	['导出Excel成功']: '导出Excel成功',
	['对话结束']: '对话结束',
	['满意度/客服']: '满意度/客服',
	['日期/客服']: '日期/客服',
	['总数']: '总数',
	['日平均']: '日平均',
	['客服日均量']: '客服日均量',
	['客服通话总量']: '客服通话总量',
	['日总量']: '日总量',
	['请输入数量']: '请输入数量',
	['满意度预设分数']: '满意度预设分数',
	['当会员未评分，会自动给予此预设分数。']: '当会员未评分，会自动给予此预设分数。',
	['设定满意度预设分数成功']: '设定满意度预设分数成功',
	['客户满意度管理']: '客户满意度管理',
	['对话结束方式']: '对话结束方式',
	['对话满意度']: '对话满意度',
	['时段']: '时段',
	['客服平均满意度']: '客服平均满意度',
	['公用设定']: '公用设定',
	['通话时长']: '通话时长',
	['服务时段']: '服务时段',
	['储存时间']: '储存时间',
	['客服不可为空']: '客服不可为空',
	['团队不可为空']: '团队不可为空',
	['请输入对话内容关键字']: '请输入对话内容关键字',
	['请输入客服本名、昵称或帐号']: '请输入客服本名、昵称或帐号',
	['平台不可为空']: '平台不可为空',
	['线上']: '线上',
	['离线']: '离线',
	['日期不可为空']: '日期不可为空',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: '亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？', // 元: 會對應該語系的幣種 e.g. 中文->人民幣 泰語->泰銖 用於客服快速生成確認金額訊息
	['您的等待顺位为第 {{pendingOrder}} 位']: '您的等待顺位为第 {{pendingOrder}} 位',

	['拒絕由 {{inviter}} 转接至 {{invitee}}']: '拒絕由 {{-inviter}} 转接至 {{-invitee}}',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: '成功由 {{-inviter}} 转接至 {{-invitee}}，共 {{count}} 则',
	['接受']: '接受',
	['拒绝({{seconds}}S)']: '拒绝({{seconds}}S)',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{-name}} 已于 {{-time}} 关闭视窗',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{-name}} 已于 {{-time}} 点选案件完成',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{-name}} 已于 {{-time}} 成功加入协作',
	['{{name}} 已于 {{time}} 离开协作']: '{{-name}} 已于 {{-time}} 离开协作',
	['{{name}} 已于 {{time}} 中断连线']: '{{-name}} 已于 {{-time}} 中断连线',
	['英文']: '英文',
	['验证码设定']: '验证码设定',
	['启用验证码']: '启用验证码',
	['设定验证码成功']: '设定验证码成功',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: '启用验证码功能后，客户需完成验证才能进入客服系统等待区。',
	['禁止连续发话']: '禁止连续发话',
	['启用禁止连续发话']: '启用禁止连续发话',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: '当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。',
	['客户端限制于']: '客户端限制于',
	['发话次数达到']: '发话次数达到',
	['次']: '次',
	['暂时无法发话']: '暂时无法发话',
	['储存完成']: '储存完成',
	['发送消息过于频繁 可稍后再试']: '发送消息过于频繁 可稍后再试',
	['IP黑名单管理']: 'IP黑名单管理',
	['共 {{total}} 笔']: '共 {{total}} 笔',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: '第 {{min}} - {{max}} 笔/共 {{total}} 笔',
	['顯示']: '顯示',
	['查询IP黑名单']: '查询IP黑名单',
	['设定自动添加黑名单']: '设定自动添加黑名单',
	['白名單管理']: '白名單管理',
	['解除时间']: '解除时间',
	['永久封锁']: '永久封锁',
	['新增IP黑名单']: '新增IP黑名单',
	['加入黑名单后，该IP将无法进入客服前台。']: '加入黑名单后，该IP将无法进入客服前台。',
	['请完成安全验证']: '请完成安全验证',
	['向右滑动填充拼图']: '向右滑动填充拼图',
	['启用功能']: '启用功能',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: '若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。',
	['限制时间']: '限制时间',
	['时间单位不可为空']: '时间单位不可为空',
	['时间单位']: '时间单位',
	['登入次数']: '登入次数',
	['封锁时间']: '封锁时间',
	['锁的持续时间，时间到了会自动解除']: '锁的持续时间，时间到了会自动解除',
	['查询IP白名单']: '查询IP白名单',
	['删除失败']: '删除失败',
	['修改失败']: '修改失败',
	['拼图验证失败次数过多']: '拼图验证失败次数过多',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{-name}} 已于 {{-time}} 拒絕加入协作',
	['储存过滤模組成功']: '储存过滤模組成功',
	['删除过滤模組成功']: '删除过滤模組成功',
	['解除谷歌验证成功']: '解除谷歌验证成功',
	['确定禁用平台?']: '确定禁用平台?',
	['确定启用平台?']: '确定启用平台?',
	['IP管理(客户端)']: 'IP管理(客户端)',
	['上传']: '上传',
	['此栏位的时间会使用于报表的团队筛选']: '此栏位的时间会使用于报表的团队筛选',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: '选择团队：筛选出该团队所有客服人员在团队统计时间中的数据',
	['备注最多{{inputLimit}}个字']: '备注最多{{inputLimit}}个字',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{-inviter}} 已于 {{-time}} 将对话从 {{-from}} 转接给 {{-invitee}}',
	['小时']: '小时',
	['日']: '日',
	['会员IP：{{ip}} 已加入前台黑名单']: '会员IP：{{ip}} 已加入前台黑名单',
	['新增失败']: '新增失败',
	['会员IP被加入黑名单']: '会员IP被加入黑名单',
	['登入/接待时间']: '登入/接待时间',
	['timePeriodTooltipMessage']: '<divAnchor><pAnchor>筛选器时段只能筛选时间不能筛选日期，如果团队统计时间设定跨日，不会随之改变日期</pAnchor><pAnchor>例如：<brAnchor/>团队统计时间设定 23:00-07:30<brAnchor/>查询 9/1 00:00-23:59<brAnchor/>筛选时间 02:00-03:00<brAnchor/>筛选后9/1数据为 9/1 02:00-03:00<brAnchor/>此数据结果与9/1团队统计时间(9/1 23:00- 9/2 07:30)没有交集，所以数据会为0<brAnchor/></pAnchor></divAnchor>',
	['平均接待时间']: '平均接待时间',
	['平均登入时间']: '平均登入时间',
	['接待时间报表']: '接待时间报表',
	['登入时间报表']: '登入时间报表',
	['未登入']: '未登入',
	['设定报表']: '设定报表',
	['设定对话是否记入报表中']: '设定对话是否记入报表中',
	['平均通话时长报表']: '平均通话时长报表',
	['平均通话数报表']: '平均通话数报表',
	['平均等待时间报表']: '平均等待时间报表',
	['客户满意度报表']: '客户满意度报表',
	['平均回覆时间报表']: '平均回覆时间报表',
	['调整原因']: '调整原因',
	['请输入调整原因']: '请输入调整原因',
	['调整原因不可为空']: '调整原因不可为空',
	['日期时间']: '日期时间',
	['操作人']: '操作人',

	['原因']: '原因',
	['更多']: '更多',
	['收回']: '收回',
	['设定报表成功']: '设定报表成功',
	['平均回覆时间']: '平均回覆时间',
	['客服平均回覆时间']: '客服平均回覆时间',
	['客户回头率']: '客户回头率',
	['客户ID']: '客户ID',
	['客服帐号']: '客服帐号',
	['小时回头率']: '小时回头率',
	['日回头率']: '日回头率',
	['遗漏时间']: '遗漏时间',
	['请选择遗漏时间']: '请选择遗漏时间',
	['平均遗漏时间']: '平均遗漏时间',
	['1分钟']: '1分钟',
	['2分钟']: '2分钟',
	['3分钟']: '3分钟',
	['4分钟']: '4分钟',
	['5分钟']: '5分钟',
	['离开时间']: '离开时间',
	['客户回头率报表']: '客户回头率报表',
	['平台报表']: '平台报表',
	['对话总量']: '对话总量',
	['接待总量']: '接待总量',
	['遗漏总量']: '遗漏总量',
	['智能客服总量']: '智能客服总量',
	['智能转客服总量']: '智能转客服总量',
	['最后更新时间']: '最后更新时间',
	['客服人数']: '客服人数',
	['在线客服总数']: '在线客服总数',
	['等待服务']: '等待服务',
	['正在服务']: '正在服务',
	['智能未转客服总量']: '智能未转客服总量',
	['使用平台']: '使用平台',
	['泰文名称']: '泰文名称',
	['请输入泰文名称']: '请输入泰文名称',
	['英文名称']: '英文名称',
	['请输入英文名称']: '请输入英文名称',
	['中文名称']: '中文名称',
	['请输入中文名称']: '请输入中文名称',

	['若无需翻译请填写中文']: '若无需翻译请填写中文',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: '帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？',
	['停用']: '停用',
	['停用帐号']: '停用帐号',
	['通话总数']: '通话总数',
	['等待中人数：{{pendingConversationCount}} 人']: '等待中人数：{{pendingConversationCount}} 人',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: '报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。',
	['汇出Load Data']: '汇出Load Data',
	['报表下载']: '报表下载',
	['全平台']: '全平台',
	['报表类型']: '报表类型',
	['数据范围']: '数据范围',
	['汇出时间']: '汇出时间',
	['完成时间']: '完成时间',
	['申请者']: '申请者',
	['下载']: '下载',
	['重新汇出']: '重新汇出',
	['处理中']: '处理中',
	['已完成']: '已完成',
	['失败']: '失败',
	['下载成功']: '下载成功',
	['历史对话纪录']: '历史对话纪录',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: '连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。',
	['引用功能管理']: '引用功能管理',
	['引用对话']: '引用对话',
	['设定引用对话成功']: '设定引用对话成功',
	['客户管理']: '客户管理',
	['重要客户帐号']: '重要客户帐号',
	['请输入重要客户帐号、备注等关键字']: '请输入重要客户帐号、备注等关键字',
	['新增重要客户']: '新增重要客户',
	['重要客户帐号不能为空']: '重要客户帐号不能为空',
	['输入多个帐号请用, 区隔']: '输入多个帐号请用, 区隔',
	['修改重要客户']: '修改重要客户',
	['重要帐号']: '重要帐号',
	['会员类型']: '会员类型',
	['引用']: '引用',
	['收回(訊息)']: '收回',
	['收回功能管理']: '收回功能管理',
	['收回提示文字不能为空']: '收回提示文字不能为空',
	['收回对话']: '收回对话',
	['收回提示文字（中文）']: '收回提示文字（中文）',
	['收回提示文字（英文）']: '收回提示文字（英文）',
	['收回提示文字（泰文）']: '收回提示文字（泰文）',
	['视频']: '视频',
	['确定要收回讯息吗？']: '确定要收回讯息吗？',
	['设定收回功能成功']: '设定收回功能成功',
	['遗漏数据']: '遗漏数据',
	['全选']: '全选',
	['请选择使用平台']: '请选择使用平台',
	['日期计算方式']: '日期计算方式',
	['以会员进入正在服务区的时间计算']: '以会员进入正在服务区的时间计算',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: '以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算',
	['以会员进入等待服务区的时间计算']: '以会员进入等待服务区的时间计算',
	['以客服接通对话的时间进行计算']: '以客服接通对话的时间进行计算',
	['以会员进入等待服务区的时间进行计算']: '以会员进入等待服务区的时间进行计算',
	['以会员点击智能客服的时间计算']: '以会员点击智能客服的时间计算',



	['相同类型才会计算回头']: '相同类型才会计算回头',
	['登入联系离开后再次登入联系']: '登入联系离开后再次登入联系',
	['一通对话只会触发一次回头次数']: '一通对话只会触发一次回头次数',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: '同一会员时间内连续联系3次，计算前两通对话的客服各1次回头',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: '每日同一会员于对话结束后{{-hour}}小时内又重复联系的有效对话比例',
	['未登入联系离开后再次未登入联系']: '未登入联系离开后再次未登入联系',
	['请输入重要客户帐号']: '请输入重要客户帐号',
	['开始日期']: '开始日期',
	['结束日期']: '结束日期',
	['标签名称/数量']: '标签名称/数量',
	['暂无数据']: '暂无数据',
	['AI客服设定']: 'AI客服设定',
	['AI共同设定']: 'AI共同设定',
	['平台AI设定']: '平台AI设定',
	['平台 AI SKILL 设定']: '平台 AI SKILL 设定',
	['指令输入说明']: '指令输入说明',
	['输入文字档']: '输入文字档',
	['不需要区分功能']: '不需要区分功能',

	['套用平台']: '套用平台',
	['请输入指令']: '请输入指令',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员',
	['指令']: '指令',
	['AI开关']: 'AI开关',
	['AI客服名称']: 'AI客服名称',
	['AI客服名称不能为空']: 'AI客服名称不能为空',
	['请输入AI客服名称']: '请输入AI客服名称',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: '是否要关闭AI客服？关闭后将无法再度开启AI客服',
	['侦测到对话有异常状态，请尽快处理']: '侦测到对话有异常状态，请尽快处理',
	['需要转接人工客服，请尽快处理']: '需要转接人工客服，请尽快处理',
	['总平均通话时长']: '总平均通话时长',
	['AI平均通话时长']: 'AI平均通话时长',
	['人工平均通话时长']: '人工平均通话时长',
	['每日总平均']: '每日总平均',
	['AI日平均']: 'AI日平均',
	['人工日平均']: '人工日平均',
	['通话总量']: '通话总量',
	['AI通话总量']: 'AI通话总量',
	['共同']: '共同',
	['总计']: '总计',
	['总计请勿超过{{limit}}字']: '总计请勿超过{{-limit}}字',

	['总平均回覆时间']: '总平均回覆时间',
	['AI平均回覆时间']: 'AI平均回覆时间',
	['人工平均回覆时间']: '人工平均回覆时间',
	['AI日总量']: 'AI日总量',
	['人工日总量']: '人工日总量',
	['指令不能为空']: '指令不能为空',

	['{{name}} 已于 {{time}} 开启AI']: '{{-name}} 已于 {{-time}} 开启AI',
	['{{name}} 已于 {{time}} 关闭AI']: '{{-name}} 已于 {{-time}} 关闭AI',
	['人机合作日总量']: '人机合作日总量',
	['人工通话总量']: '人工通话总量',
	['人机合作通话总量']: '人机合作通话总量',
	['以对话建立时间计算']: '以对话建立时间计算',
	['侦测到对话有异常状态 - 对话次数超过限制']: '侦测到对话有异常状态 - 对话次数超过限制',
	['侦测到对话有异常状态 - 系统发生错误']: '侦测到对话有异常状态 - 系统发生错误',
	['人机合作-人工日平均']: '人机合作-人工日平均',
	['人机合作-AI日平均']: '人机合作-AI日平均',
	['人机合作-人工平均通话时长']: '人机合作-人工平均通话时长',
	['人机合作-AI平均通话时长']: '人机合作-AI平均通话时长',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: '侦测到对话有异常状态 - 等待AI API超过两分钟',
	['侦测到对话有异常状态 - AI 发生错误']: '侦测到对话有异常状态 - AI 发生错误',
	['侦测到对话有异常状态 - AI 没有回复']: '侦测到对话有异常状态 - AI 没有回复',
	['数据']: '数据',
	['指令不能超过{{limit}}字']: '指令不能超过{{-limit}}字',

	['数据不能为空']: '数据不能为空',
	['数据不能超过100万字']: '数据不能超过100万字',
	['需{{limit}}字以内']: '需{{-limit}}字以内',
	['数据输入说明']: '数据输入说明',
	['需100万字以内']: '需100万字以内',
	['至少要有一组 ~~~~~ 与 =====']: '至少要有一组 ~~~~~ 与 =====',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: '分隔符号 ~~~~~ 与 ===== 需成对出现',
	['需以 ===== 结尾']: '需以 ===== 结尾',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: '标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: '内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格',
	['范例']: '范例',
	['标题A（可多行）']: '标题A（可多行）',
	['内容A（可多行，可含任何文字）']: '内容A（可多行，可含任何文字）',
	['标题B（可多行）']: '标题B（可多行）',
	['内容B（可多行，可含任何文字）']: '内容B（可多行，可含任何文字）',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: '模型顺序（上方模型优先使用，失效时自动往下切换）',
	['主要']: '主要',
	['备援{{index}}']: '备援{{index}}',
	['新增备援模型']: '新增备援模型',
	['请输入数据']: '请输入数据',
	['正在转接中...']: '正在转接中...',
	['（中文）']: '（中文）',
	['（英文）']: '（英文）',
	['（泰文）']: '（泰文）',
	['（越南文）']: '（越南文）',
	['越南文名称']: '越南文名称',
	['请输入越南文名称']: '请输入越南文名称',
	['模式']: '模式',

	['越南语']: '越南语',
	['IP白名单设定']: 'IP白名单设定',
	['建立时间']: '建立时间',
	['批次删除']: '批次删除',
	['请确认是否删除 IP 白名单？']: '请确认是否删除 IP 白名单？',

	['开启快捷选单']: '开启快捷选单',
	['收合快捷选单']: '收合快捷选单',
	['是否有收回人员讯息']: '是否有收回人员讯息',
	['是否有收回AI讯息']: '是否有收回AI讯息',
	['消息已被客服撤回']: '消息已被客服撤回',
	['用户快捷选单管理']: '用户快捷选单管理',
	['电脑预览']: '电脑预览',
	['手机预览']: '手机预览',
	['档案格式：PNG、JPG、JPEG']: '档案格式：PNG、JPG、JPEG',
	['请选择上传档案']: '请选择上传档案',
	['新增快捷成功']: '新增快捷成功',
	['修改快捷成功']: '修改快捷成功',
	['设定快捷选单成功']: '设定快捷选单成功',
	['删除快捷成功']: '删除快捷成功',
	['确定删除此快捷？']: '确定删除此快捷？',
	['新增内容']: '新增内容',
	['选项內容']: '选项內容',
	['{{itemLabel}}內容不能为空']: '{{-itemLabel}}內容不能为空',
	['请输入{{itemLabel}}标题']: '请输入{{-itemLabel}}标题',
	['请输入{{itemLabel}}选项']: '请输入{{-itemLabel}}选项',
	['{{text}}不可为空']: '{{-text}}不可为空',
	['显示更多']: '显示更多',
	['公告标签']: '公告标签',
	['请选择公告标签']: '请选择公告标签',
	['{{text}}标题']: '{{-text}}标题',
	['{{text}}內文']: '{{-text}}內文',
	['{{text}}最多{{inputLimit}}个字']: '{{-text}}最多{{inputLimit}}个字',
	['公告内文档案大小总计不得大于10MB']: '公告内文档案大小总计不得大于10MB',
	['用户尚未离开，确认要完成对话？']: '用户尚未离开，确认要完成对话？',
	['{{name}} 已于 {{time}} 离开对话']: '{{-name}} 已于 {{-time}} 离开对话',
	['客服人员']: '客服人员',
	['*新增多个IP请使用逗号「 , 」隔开']: '*新增多个IP请使用逗号「 , 」隔开',
	['是否新增IP白名单？']: '是否新增IP白名单？',
	['IP已存在']: 'IP已存在',

	['监控区管理']: '监控区管理',
	['监控区开关']: '监控区开关',
	['设定监控区开关成功']: '设定监控区开关成功',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: '启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。',
	['{{name}} 新增了标签 {{tag}}']: '{{-name}} 新增了标签 {{-tag}}',
	['{{name}} 移除了标签 {{tag}}']: '{{-name}} 移除了标签 {{-tag}}',
	['状态切换为暂离']: '状态切换为暂离',
	['状态切换为工作中']: '状态切换为工作中',
	['监控区']: '监控区',
	['自动接线管理']: '自动接线管理',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: '客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。',
	['自动接线数量上限']: '自动接线数量上限',
	['设定自动接线成功']: '设定自动接线成功',
	['{{name}} 进线']: '{{-name}} 进线',
	['工作/暂离时间']: '工作/暂离时间',
	['工作时长报表']: '工作时长报表',
	['暂离时长报表']: '暂离时长报表',
	['平均工作时长']: '平均工作时长',
	['平均暂离时长']: '平均暂离时长',
	['关键字提醒']: '关键字提醒',
	['客户发话']: '客户发话',
	['AI发话']: 'AI发话',
	['发话来源']: '发话来源',
	['请输入发话来源、关键字']: '请输入发话来源、关键字',
	['新增关键字']: '新增关键字',
	['修改关键字']: '修改关键字',
	['新增关键字成功']: '新增关键字成功',
	['修改关键字成功']: '修改关键字成功',
	['删除关键字成功']: '删除关键字成功',
	['是否删除此关键字？']: '是否删除此关键字？',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: '请用「；」来分隔不同关键字，关键字不得超过100个字',
	['客户触发关键字 [{{word}}] 请客服人员注意']: '客户触发关键字 [{{-word}}] 请客服人员注意',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'AI触发关键字 [{{-word}}] 请客服人员注意',
	['请输入通知时间']: '请输入通知时间',
	['自动接线开关']: '自动接线开关',
	['自动接线数量上限不可为空']: '自动接线数量上限不可为空',
	['请输入数量上限']: '请输入数量上限',
	['离开状态侦测开关']: '离开状态侦测开关',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: '开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。',
	['离开时间通知开关']: '离开时间通知开关',
	['通知时间不可重复']: '通知时间不可重复',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: '侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。',
	['最后暂离时间报表']: '最后暂离时间报表',
	['平均最后暂离时间']: '平均最后暂离时间',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: '{{-name}} 离开时间已达 [{{minute}}] 分钟 !',
	['历史对话记录下载']: '历史对话记录下载',
	['使用模式']: '使用模式',
	['标准模式']: '标准模式',
	['ID模式']: 'ID模式',
	['即进模式']: '即进模式',
	['复制即进网址']: '复制即进网址',
	['生成新网址']: '生成新网址',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: '需提供客户Profile资料的标准模式，此模式为系统预设模式。',
	['输入ID 进入客服，可不提供客戶Profile资料。']: '输入ID 进入客服，可不提供客戶Profile资料。',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: '透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: '请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]',
	['以下是即进网址']: '以下是即进网址',
	['复制网址']: '复制网址',
	['使用模式切换成功']: '使用模式切换成功',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: '请再次确认是否更换网址 ，一经更换<<redText>>',
	['当前即进网址']: '当前即进网址',
	['新即进网址']: '新即进网址',
	['复制即进网址成功']: '复制即进网址成功',
	['报表统计']: '报表统计',
	['操作時間']: '操作時間',
	['统计类型']: '统计类型',
	['请选择统计类型']: '请选择统计类型',
	['查询参数']: '查询参数',
	['申请时间']: '申请时间',
	['产出时间']: '产出时间',
	['申请帐号']: '申请帐号',
	['详细资料']: '详细资料',
	['重新执行统计']: '重新执行统计',
	['执行统计']: '执行统计',
	['登入时间范围']: '登入时间范围',
	['选择团队：筛选出该团队所有客服人员']: '选择团队：筛选出该团队所有客服人员',
	['API接收日志']: 'API接收日志',
	['新增来源']: '新增来源',
	['CS']: 'CS',
	['包网']: '包网',
	['包网API']: '包网API',
	['第 {{min}} - {{max}} 笔']: '第 {{-min}} - {{-max}} 笔',
	['选择的日期区间需小于等于{{limit}}天']: '选择的日期区间需小于等于{{-limit}}天',
	['请选择日期时间查询条件']: '请选择日期时间查询条件',
	['类型']: '类型',
	['公司']: '公司',
	['请输入公司']: '请输入公司',
	['会员帐号']: '会员帐号',
	['请输入会员帐号']: '请输入会员帐号',
	['是否查看详细资料？']: '是否查看详细资料？',
	['传送资料']: '传送资料',
	['CS回覆资料']: 'CS回覆资料',
	['内容']: '内容',
	['请选择进入的公司']: '请选择进入的公司',
	['指令数据更新纪录']: '指令数据更新纪录',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: '1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: '2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。',
	['微调训练']: '微调训练',
	['执行微调']: '执行微调',
	['操作帐号']: '操作帐号',
	['是否修改AI API?']: '是否修改AI API?',
	['保存设置']: '保存设置',
	['修改AI API成功']: '修改AI API成功',
	['请输入{{text}}']: '请输入{{-text}}',
	['{{text}}不能超过{{limit}}字元']: '{{-text}}不能超过{{-limit}}字元',
	['AI API']: 'AI API',
	['微调训练记录']: '微调训练记录',
	['模型名称']: '模型名称',
	['新增文本']: '新增文本',
	['修改文本']: '修改文本',
	['请输入名称']: '请输入名称',
	['取消修改微调文本']: '取消修改微调文本',
	['角色不可为空']: '角色不可为空',
	['请选择角色']: '请选择角色',
	['内容不可为空']: '内容不可为空',
	['请输入内容']: '请输入内容',
	['系统']: '系统',
	['会员']: '会员',
	['AI']: 'AI',
	['请确认是否取消？']: '请确认是否取消？',
	['新增微调文本成功']: '新增微调文本成功',
	['修改微调文本成功']: '修改微调文本成功',
	['自定模型名称']: '自定模型名称',
	['微调确认讯息']: '微调确认讯息',
	['请确认是否执行微调训练？']: '请确认是否执行微调训练？',
	['删除微调文本']: '删除微调文本',
	['请确认是否刪除？']: '请确认是否刪除？',
	['刪除微调文本成功']: '刪除微调文本成功',
	['请输入模型名称']: '请输入模型名称',
	['执行微调成功']: '执行微调成功',
	['取消修改文本成功']: '取消修改文本成功',
	['取消新增文本成功']: '取消新增文本成功',
	['您已成功登出客服系统。']: '您已成功登出客服系统。',
	['如需重新登录，请返回包网！']: '如需重新登录，请返回包网！',
	['您已成功登出客服系统管理端。']: '您已成功登出客服系统管理端。',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: '当「平均等待时间」显示为 0 秒时，可能的原因如下：',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: '1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: '系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。',
	['加入微调']: '加入微调',
	['启用API Key']: '启用API Key',
	['微调汇入对话记录']: '微调汇入对话记录',
	['对话数量']: '对话数量',
	['文本最后角色需为AI或客服人员']: '文本最后角色需为AI或客服人员',
	['汇入微调文本']: '汇入微调文本',
	['檔案格式：CSV，且档案大小不得大于']: '檔案格式：CSV，且档案大小不得大于',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: '文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调',
	['批量加入微调']: '批量加入微调',
	['自定加入微调的名称']: '自定加入微调的名称',
	['微调名称']: '微调名称',
	['请输入微调的名称']: '请输入微调的名称',
	['微调的名称']: '微调的名称',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: '请确认是否批量删除(共 {{-selectedFineTuningRecordsLength}} 笔',
	['已取消']: '已取消',
	['取消微调']: '取消微调',
	['取消微调成功']: '取消微调成功',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: '取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？',
	['复制快捷语成功']: '复制快捷语成功',
	['复制常用图片成功']: '复制常用图片成功',
	['左侧']: '左侧',
	['右侧']: '右侧',
	['{{text}}正在服务{{total}}则对话']: '{{-text}}正在服务{{-total}}则对话',
	['新增跑马灯成功']: '新增跑马灯成功',
	['修改跑马灯成功']: '修改跑马灯成功',
	['刪除跑马灯成功']: '刪除跑马灯成功',
	['启用跑马灯成功']: '启用跑马灯成功',
	['停用跑马灯成功']: '停用跑马灯成功',
	['对象栏位']: '对象栏位',
	['显示跑马灯内容']: '显示跑马灯内容',
	['请确认是否启用跑马灯？']: '请确认是否启用跑马灯？',
	['请确认是否停用跑马灯？']: '请确认是否停用跑马灯？',
	['请确认是否删除跑马灯？']: '请确认是否删除跑马灯？',
	['{{text}}最多{{inputLimit}}组']: '{{text}}最多{{inputLimit}}组',
	['数值范围']: '数值范围',
	['数值不能为空']: '数值不能为空',
	['数值']: '数值',
	['请输入数字']: '请输入数字',
	['输入多组文字请用, 区隔']: '输入多组文字请用, 区隔',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: '当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广',
	['新增跑马灯']: '新增跑马灯',
	['对象栏位不能为空']: '对象栏位不能为空',
	['请输入对象栏位']: '请输入对象栏位',
	['栏位规则']: '栏位规则',
	['栏位规则不能为空']: '栏位规则不能为空',
	['请选择栏位规则']: '请选择栏位规则',
	['开头图示']: '开头图示',
	['开头图示不能为空']: '开头图示不能为空',
	['请选择开头图示']: '请选择开头图示',
	['跑马灯内容']: '跑马灯内容',
	['修改跑马灯']: '修改跑马灯',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: '变更的平台设定将同步套用至下级角色，是否确认修改？',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: '确认要删除[个人/公共]常用图片[{{title}}]吗？',
	['一经确认删除无法复原。']: '一经确认删除无法复原。',
	['客服日志']: '客服日志',
	['请输入内容等关键字']: '请输入内容等关键字',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: '确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？',
	['没有其他进入标签被开启，故无法关闭此进入标签']: '没有其他进入标签被开启，故无法关闭此进入标签',
	['没有其他进入标签被开启，故无法删除此标签']: '没有其他进入标签被开启，故无法删除此标签',
	['所有人']: '所有人',
	['自定义对象']: '自定义对象',
	['套用对象']: '套用对象',
	['回主画面']: '回主画面',
	['孟加拉语']: '孟加拉语',
	['繁体中文']: '繁体中文',
	['简体中文']: '简体中文',
	['韩语']: '韩语',
	['日语']: '日语',
	['葡萄牙语']: '葡萄牙语',
	['印地语']: '印地语',
	['俄语']: '俄语',
	['重要资讯']: '重要资讯',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: '在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?',
	['暂无对话']: '暂无对话',
	['触发关键字：{{keywords}}。']: '触发关键字：{{-keywords}}。',
	['档案上传中']: '档案上传中',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{-name}} 已于 {{-time}} 开启自动推播',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{-name}} 已于 {{-time}} 关闭自动推播',
	['同义词设定']: '同义词设定',
	['开启BM25']: '开启BM25',
	['启用显性快取']: '启用显性快取',
	['同义词']: '同义词',
	['更新时间']: '更新时间',
	['批次新增同义词']: '批次新增同义词',
	['修改同义词']: '修改同义词',
	['新增同义词']: '新增同义词',
	['请输入同义词，使用逗号区隔不同词汇']: '请输入同义词，使用逗号区隔不同词汇',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: '请以逗号区隔不同词汇，用分号区隔不同组同义词',
	['输入格式说明：']: '输入格式说明：',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: '请用，区隔不同词汇，例如：充值,储值,入金,课金',
	['词汇与标点符号前后不要出现空白']: '词汇与标点符号前后不要出现空白',
	['请用；或分行(enter)区隔同组同义词，例如：']: '请用；或分行(enter)区隔同组同义词，例如：',
	['充值,储值,入金,课金']: '充值,储值,入金,课金',
	['log in,登入;亲,宝贝']: 'log in,登入;亲,宝贝',
	['请输入同义词']: '请输入同义词',
	['同义词不可为空']: '同义词不可为空',
	['同义词格式有误']: '同义词格式有误',
	['同义词不可有特殊字元']: '同义词不可有特殊字元',
	['字元不可超过10000']: '字元不可超过10000',
	['需至少输入两个词汇']: '需至少输入两个词汇',
	['删除同义词']: '删除同义词',
	['请确认是否删除同义词？']: '请确认是否删除同义词？',
	['新增同义词成功']: '新增同义词成功',
	['新增同义词失败']: '新增同义词失败',
	['修改同义词成功']: '修改同义词成功',
	['修改同义词失败']: '修改同义词失败',
	['删除同义词成功']: '删除同义词成功',
	['删除同义词失败']: '删除同义词失败',
	['内容有重复字']: '内容有重复字',
	['新增图片，详细图片请参考公告管理']: '新增图片，详细图片请参考公告管理',
	['目前只支援ChatGPT进行微调训练']: '目前只支援ChatGPT进行微调训练',
	['AI系列']: 'AI系列',
	['AI系列不能为空']: 'AI系列不能为空',
	['启用ChatGPT']: '启用ChatGPT',
	['启用Gemini']: '启用Gemini',
	['商户代码']: '商户代码',
	['请输入商户代码']: '请输入商户代码',
	['密钥']: '密钥',
	['请输入密钥']: '请输入密钥',
	['共同设定']: '共同设定',
	['充值未到帐设定']: '充值未到帐设定',
	['出款未到帐设定']: '出款未到帐设定',
	['确认进行储存？']: '确认进行储存？',
	['SKILL开关']: 'SKILL开关',
	['请输入SKILL']: '请输入SKILL',
	['派单 API 参数']: '派单 API 参数',
	['请输入派单API URL']: '请输入派单API URL',
	['开单者username']: '开单者username',
	['请输入开单者username']: '请输入开单者username',
	['频道名称']: '频道名称',
	['请输入频道名称']: '请输入频道名称',
	['开单原因']: '开单原因',
	['请输入开单原因']: '请输入开单原因',
	['充值订单查询 API URL']: '充值订单查询 API URL',
	['出款订单查询 API URL']: '出款订单查询 API URL',
	['AI客服']: 'AI客服',
	['ID入口']: 'ID入口',
	['IP']: 'IP',
	['USER ID']: 'USER ID',
	['{{itemLabel}}內容不可为空']: '{{itemLabel}}內容不可为空',
	['{{text}}仅能输入数字']: '{{text}}仅能输入数字',
	['{{text}}最多{{limit}}个字元']: '{{text}}最多{{limit}}个字元',
	['{{text}}最多數字{{limit}}碼']: '{{text}}最多數字{{limit}}碼',
	['{{time}}分']: '{{time}}分',
	['{{time}}时']: '{{time}}时',
	['{{time}}秒']: '{{time}}秒',
	['上一则发送后等待时间']: '上一则发送后等待时间',
	['上传图片']: '上传图片',
	['主要API keys']: '主要API keys',
	['主要语言']: '主要语言',
	['事件']: '事件',
	['以查看预览效果']: '以查看预览效果',
	['依照选择模组设定UI显示位置及功能。']: '依照选择模组设定UI显示位置及功能。',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: '依照选择的风格进行调整配色（含背景、框体、配色、线条感）。',
	['修改帐号履历成功']: '修改帐号履历成功',
	['修改翻译API成功']: '修改翻译API成功',
	['充值帐号']: '充值帐号',
	['共 {{numOfItems}} 笔']: '共 {{numOfItems}} 笔',
	['关 闭']: '关 闭',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: '关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。',
	['内容最多20字元']: '内容最多20字元',
	['内容预览']: '内容预览',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: '切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定',
	['删除履历']: '删除履历',
	['删除帐号履历成功']: '删除帐号履历成功',
	['删除跑马灯']: '删除跑马灯',
	['加载中...']: '加载中...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: '勾选后，该账号在联系客服时，账号名称旁会显示',
	['即时预览']: '即时预览',
	['取消新增微调文本']: '取消新增微调文本',
	['古典深色风格']: '古典深色风格',
	['單次']: '單次',
	['回传表单']: '回传表单',
	['外观风格']: '外观风格',
	['客户端视觉设定']: '客户端视觉设定',
	['客户端视觉设定成功']: '客户端视觉设定成功',
	['尚无资料']: '尚无资料',
	['展开']: '展开',
	['履历数量']: '履历数量',
	['帐号履历']: '帐号履历',
	['帐号履历管理']: '帐号履历管理',
	['平台代码不能有空白']: '平台代码不能有空白',
	['平台代码仅能输入英文和数字']: '平台代码仅能输入英文和数字',
	['平台代码最多5码']: '平台代码最多5码',
	['平台代码最少2码']: '平台代码最少2码',
	['平台语言']: '平台语言',
	['平均首次工作时间']: '平均首次工作时间',
	['建立者']: '建立者',
	['开关']: '开关',
	['快速通道']: '快速通道',
	['手动推播']: '手动推播',
	['手机版']: '手机版',
	['批量删除']: '批量删除',
	['排序']: '排序',
	['推播功能']: '推播功能',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: '推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。',
	['推播时间']: '推播时间',
	['推播讯息列表']: '推播讯息列表',
	['推播设定']: '推播设定',
	['操作内容']: '操作内容',
	['收起']: '收起',
	['数值/内容']: '数值/内容',
	['数值/内容不可为空']: '数值/内容不可为空',
	['数值只能输入数字、负号、小数点']: '数值只能输入数字、负号、小数点',
	['数值小数最多6位数']: '数值小数最多6位数',
	['数值整数最多15位']: '数值整数最多15位',
	['新增履历']: '新增履历',
	['新增帐号履历成功']: '新增帐号履历成功',
	['新增类型']: '新增类型',
	['无工作']: '无工作',
	['时间设定需至少为 3 分钟']: '时间设定需至少为 3 分钟',
	['是否修改翻译API?']: '是否修改翻译API?',
	['更新成功']: '更新成功',
	['更新者']: '更新者',
	['架构模组']: '架构模组',
	['栏位名称']: '栏位名称',
	['栏位类型']: '栏位类型',
	['栏位类型不可为空']: '栏位类型不可为空',
	['档案格式不符']: '档案格式不符',
	['PDF文件']: 'PDF文件',
	['模式与间隔时间']: '模式与间隔时间',
	['欢迎回来']: '欢迎回来',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: '此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？',
	['汇入']: '汇入',
	['汇入微调文本成功']: '汇入微调文本成功',
	['汇出微调文本成功']: '汇出微调文本成功',
	['清空翻译']: '清空翻译',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: '所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系',
	['标题与内容皆需填写才可自动翻译']: '标题与内容皆需填写才可自动翻译',
	['状态持续时间']: '状态持续时间',
	['用户帐号']: '用户帐号',
	['用户帐号不能为空']: '用户帐号不能为空',
	['电脑版']: '电脑版',
	['目前无适用推播']: '目前无适用推播',
	['目前有启用中的侦测语言平台，无法关闭']: '目前有启用中的侦测语言平台，无法关闭',
	['确定删除IP白名单？']: '确定删除IP白名单？',
	['确定发送推播？']: '确定发送推播？',
	['确定要关闭推播功能吗？']: '确定要关闭推播功能吗？',
	['确认删除此笔履历?']: '确认删除此笔履历?',
	['确认要删除推播讯息？']: '确认要删除推播讯息？',
	['立即登入']: '立即登入',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: '第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔',
	['筛选条件']: '筛选条件',
	['类型名称']: '类型名称',
	['系统预设模组']: '系统预设模组',
	['经典浅色风格']: '经典浅色风格',
	['翻译API']: '翻译API',
	['聊天介面']: '聊天介面',
	['自动推播']: '自动推播',
	['自动推播功能']: '自动推播功能',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: '自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。',
	['自定义']: '自定义',
	['自定义文案']: '自定义文案',
	['自客服接起对话后开始计算']: '自客服接起对话后开始计算',
	['该类型目前有推播讯息套用中，无法删除']: '该类型目前有推播讯息套用中，无法删除',
	['详细说明']: '详细说明',
	['请先选择推播类型']: '请先选择推播类型',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: '请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？',
	['请输入事件']: '请输入事件',
	['请输入会员ID']: '请输入会员ID',
	['请输入內容']: '请输入內容',
	['请输入关键字']: '请输入关键字',
	['请输入您的会员 ID 以继续']: '请输入您的会员 ID 以继续',
	['请输入数值/内容']: '请输入数值/内容',
	['请输入文字']: '请输入文字',
	['请输入栏位名称']: '请输入栏位名称',
	['请输入用户帐号']: '请输入用户帐号',
	['请输入类型名称']: '请输入类型名称',
	['请输入详细说明']: '请输入详细说明',
	['请选择上方下拉选单']: '请选择上方下拉选单',
	['请选择主要语言自动翻译']: '请选择主要语言自动翻译',
	['请选择帐号状态']: '请选择帐号状态',
	['请选择平台']: '请选择平台',
	['请选择推播项目']: '请选择推播项目',
	['请选择栏位类型']: '请选择栏位类型',
	['请选择类型']: '请选择类型',
	['请选择类型与项目(标题)以预览内容']: '请选择类型与项目(标题)以预览内容',
	['请选择表单选项']: '请选择表单选项',
	['请选择运算规则']: '请选择运算规则',
	['请选择预览画面']: '请选择预览画面',
	['跑马灯设定']: '跑马灯设定',
	['轮播']: '轮播',
	['轮播模式']: '轮播模式',
	['轮播间隔时间']: '轮播间隔时间',
	['运算规则']: '运算规则',
	['运算规则不可为空']: '运算规则不可为空',
	['返回上一层']: '返回上一层',
	['返回上一页']: '返回上一页',
	['送出推播']: '送出推播',
	['选单介面']: '选单介面',
	['选择推播类型']: '选择推播类型',
	['选择推播项目(标题)']: '选择推播项目(标题)',
	['通知时间']: '通知时间',
	['通知时间不能为空']: '通知时间不能为空',
	['重新产生Key/IV']: '重新产生Key/IV',
	['重要客户']: '重要客户',
	['需为1~60正整数']: '需为1~60正整数',
	['预估时间']: '预估时间',
	['预览图片']: '预览图片',
	['首次工作时间报表']: '首次工作时间报表',
	['日志管理']: '日志管理',
	['API传送日志']: 'API传送日志',
	['订单号']: '订单号',
	['三方单号']: '三方单号',
	['请输入订单号']: '请输入订单号',
	['请输入三方单号']: '请输入三方单号',
	['充值订单查询']: '充值订单查询',
	['出款订单查询']: '出款订单查询',
	['开派单']: '开派单',
	['传送派单信息']: '传送派单信息',
	['CS传送资料']: 'CS传送资料',
	['平台回覆资料']: '平台回覆资料',
	['{{text}}需以{{prefix}}开头']: '{{-text}}需以{{-prefix}}开头',
	['系统通知']: '系统通知',
	['派单传送讯息']: '派单传送讯息',
	['派单传送档案']: '派单传送档案',
	['请输入平台']: '请输入平台',
	['派单讯息润饰设定']: '派单讯息润饰设定',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: '此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用',
	['用户个人设定']: '用户个人设定',
	['新增用户个人资讯']: '新增用户个人资讯',
	['个人资讯参数名称']: '个人资讯参数名称',
	['请输入个人资讯参数名称']: '请输入个人资讯参数名称',
	['*新增多个请使用逗号「 , 」隔开']: '*新增多个请使用逗号「 , 」隔开',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: '用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI',
	['批次删除用户个人资讯']: '批次删除用户个人资讯',
	['确定要批次删除用户个人资讯吗？']: '确定要批次删除用户个人资讯吗？',
	['个人资讯参数名称不能为空']: '个人资讯参数名称不能为空',
	['已存在「{{name}}」']: '已存在「{{-name}}」',
	['最多可新增{{limit}}个，已超过上限']: '最多可新增{{-limit}}个，已超过上限',
	['新增用户个人资讯成功']: '新增用户个人资讯成功',
	['新增用户个人资讯失败']: '新增用户个人资讯失败',
	['删除用户个人资讯成功']: '删除用户个人资讯成功',
	['删除用户个人资讯失败']: '删除用户个人资讯失败',
	['图像管理']: '图像管理',
	['自定义图像']: '自定义图像',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: '档案格式：“PNG、JPG”档案大小不得大于 500KB',
	['档案最大500K']: '档案最大500K',
	['新增图像成功']: '新增图像成功',
	['删除图像成功']: '删除图像成功',
	['是否确定删除图像？']: '是否确定删除图像？',
	['内容设定']: '内容设定',
	['英语']: '英语',
	['{{language}}内容']: '{{language}}内容',
	['请输入{{language}}内容']: '请输入{{language}}内容',
	['请选择时间']: '请选择时间',
	['请选择公司']: '请选择公司',
	['请输入{{label}}']: '请输入{{label}}',
	['原文参考（{{language}}）']: '原文参考（{{language}}）',
	['确定清空设定吗？']: '确定清空设定吗？',
	['确定取消设定吗？']: '确定取消设定吗？',
	['{{language}}{{tab}}']: '{{language}}{{tab}}',
	['未完成']: '未完成',
	['{{language}}{{label}}超过{{limit}}字']: '{{language}}{{label}}超过{{limit}}字',
	['公告标题']: '公告标题',
	['进线IP']: '进线IP',
	['请输入进线IP']: '请输入进线IP',
	['模型切换：{{fromModel}} -> {{toModel}}']: '模型切换：{{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: '包网后台删除帐号后，客服系统帐号将同步删除',
	['系统已有新版本，请重新整理']: '系统已有新版本，请重新整理',
	['页面加载失败，请重试']: '页面加载失败，请重试',
	['监控与即时摘要设定']: '监控与即时摘要设定',
	['生成链接']: '生成链接',
	['链接生成中...']: '链接生成中...',
	['复制链接']: '复制链接',
	['已复制链接']: '已复制链接',
	['档案上传失败']: '档案上传失败',
	['转档失败，请重新上传']: '转档失败，请重新上传',
	['人工回复']: '人工回复',
	['检视回复']: '检视回复',
	['{{time}} AI 拦截对话']: '{{time}} AI 拦截对话',
	['AI 拦截原因与人工回复']: 'AI 拦截原因与人工回复',
	['人工回复失败']: '人工回复失败',
	['回复讯息']: '回复讯息',
	['对话摘要']: '对话摘要',
	['建议回复']: '建议回复',
	['拦截原因']: '拦截原因',
	['拦截回复']: '拦截回复',
	['确定送出']: '确定送出',
	['生成链接失败']: '生成链接失败',
	['连接超时，请稍后再试']: '连接超时，请稍后再试',
	['上一则']: '上一则',
	['下一则']: '下一则',
	['重新传送']: '重新传送',
	['传送中...']: '传送中...',
	['用户端翻译失败']: '用户端翻译失败',
	['重新传送失败']: '重新传送失败',
	['请确认是否删除以下模型？']: '请确认是否删除以下模型？',
	['新增模型']: '新增模型',
	['请选择AI系列']: '请选择AI系列',
	['支援模型']: '支援模型',
	['支援模型不能为空']: '支援模型不能为空',
	['请选择支援模型']: '请选择支援模型',
	['AI模型管理']: 'AI模型管理',
	['模型不能为空']: '模型不能为空',
	['请选择模型']: '请选择模型',

	['对话类型']: '对话类型',
	['单纯AI讯息']: '单纯AI讯息',
	['单纯人员讯息']: '单纯人员讯息',
	['人员+AI讯息']: '人员+AI讯息',
	['是否经过AI拦截']: '是否经过AI拦截',
	['是否修改AI拦截建议回覆']: '是否修改AI拦截建议回覆',
	['监控API keys']: '监控API keys',
	['管理']: '管理',

	['AI监控拦截总量']: 'AI监控拦截总量',
	['AI监控拦截']: 'AI监控拦截',
	['有修改建议回覆总量']: '有修改建议回覆总量',

	['版面已套用，但尚未同步至帐号']: '版面已套用，但尚未同步至帐号',
	['服务器重设失败，下次开启工作区时会再同步']: '服务器重设失败，下次开启工作区时会再同步',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: '浏览器无法储存版面，离开前请确认帐号同步完成',

	['重设版面配置']: '重设版面配置',
	['确定要将版面配置回复为系统预设吗？']: '确定要将版面配置回复为系统预设吗？',
	['客服支援语言']: '客服支援语言',
	['请选择支援语言']: '请选择支援语言',
	['请选择客服支援语言']: '请选择客服支援语言',

	['删除平台']: '删除平台',
	['是否确定删除{{code}}平台']: '是否确定删除{{-code}}平台',
	['删除{{code}}平台成功']: '删除{{-code}}平台成功',
	['上传图片或PDF']: '上传图片或PDF',
	['当前平台维护中，如有疑问请联系管理员']: '当前平台维护中，如有疑问请联系管理员',
	['当前平台已禁用，如有疑问请联系管理员']: '当前平台已禁用，如有疑问请联系管理员',
	['收回提示文字']: '收回提示文字',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: '请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！',
	['标签名称']: '标签名称',
	['预览失败']: '预览失败',
	['放大']: '放大',
	['缩小']: '缩小',
	['上一页']: '上一页',
	['下一页']: '下一页',
	['点击预览']: '点击预览',
};
